import { render, staticRenderFns } from "./NewcareCTA.vue?vue&type=template&id=813eb86c&scoped=true"
import script from "./NewcareCTA.vue?vue&type=script&lang=js"
export * from "./NewcareCTA.vue?vue&type=script&lang=js"
import style0 from "./NewcareCTA.vue?vue&type=style&index=0&id=813eb86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813eb86c",
  null
  
)

export default component.exports